<template>
  <div class="purchase">
    <div class="block">
      <div class="subscription-plan-data">
        <div class="subscription-plan-container">
          <PurchaseOption
            :showCurrency="showCurrency"
            :purchaseOption="purchaseOptionToShow"
            :selected="true"
            :view="view"
          />
        </div>
        <div class="text" v-if="promotionalCode">
          <h4 class="commercial">
            {{ promotionalCode.commercial_text }}
          </h4>
          <p class="legal">
            {{ promotionalCode.legal_text }}
          </p>
        </div>
      </div>

      <PurchaseOptionLegals
        :purchaseOption="purchaseOptionToShow"
        :showCurrency="showCurrency"
        :include-option-description="true"
        :showAddOnLegacy="showAddOnLegacy"
      />

      <p class="currency-disclaimer">
        {{
          $t("subscription.currency_disclaimer", {
            currency_description: showCurrency.description,
            currency_code: showCurrency.code,
            currency_symbol: showCurrency.symbol,
          })
        }}
      </p>

      <div class="buttons-container" v-if="!onlyOneOption">
        <button type="button" class="btn back active" @click="backHandler">
          {{ $t("subscription.buttons.back") }}
        </button>
      </div>

      <template v-if="!hideFormComponent">
        <template v-if="!$auth.check()">
          <div class="login">
            <button type="button" class="btn back active" @click="loginHandler">
              {{ $t("register.account") }}
              <!-- Pagar usando -->
            </button>
            <h5 class="text">{{ $t("single_text.or") }}</h5>
          </div>
        </template>

        <template v-if="subscriptionPlan">
          <div class="payment-methods-container">
            <template v-if="subscriptionPlan.payment_methods.data.length > 1">
              <PaymentMethodGroup
                v-if="
                  subscriptionPlan.payment_methods.data.some(
                    (payment_method) => payment_method.group === 'recommended'
                  )
                "
                :type="'recommended'"
                :selected-payment-method="selectedPaymentMethod"
                :payment-methods="
                  subscriptionPlan.payment_methods.data.filter(
                    (payment_method) => payment_method.group === 'recommended'
                  )
                "
                @click="setPaymentMethod"
              />
              <PaymentMethodGroup
                v-if="
                  subscriptionPlan.payment_methods.data.some(
                    (payment_method) => payment_method.group === 'others'
                  )
                "
                :type="'others'"
                :selected-payment-method="selectedPaymentMethod"
                :payment-methods="
                  subscriptionPlan.payment_methods.data.filter(
                    (payment_method) => payment_method.group === 'others'
                  )
                "
                @click="setPaymentMethod"
              />
              <PaymentMethodGroup
                v-if="
                  subscriptionPlan.payment_methods.data.some(
                    (payment_method) => payment_method.group === 'try-again'
                  )
                "
                :type="'try-again'"
                :selected-payment-method="selectedPaymentMethod"
                :payment-methods="
                  subscriptionPlan.payment_methods.data.filter(
                    (payment_method) => payment_method.group === 'try-again'
                  )
                "
                @click="setPaymentMethod"
              />
            </template>
            <template
              v-else-if="subscriptionPlan.payment_methods.data.length === 1"
            >
              <div class="single-payment-method">
                <h5 class="action">
                  {{ $t("subscription.buttons.pay_using") }}
                </h5>
                <div
                  class="payment-method-img"
                  :style="{
                    backgroundImage: `url('${selectedPaymentMethod.image_url}')`,
                  }"
                ></div>
              </div>
            </template>
            <div v-else>
              <template v-if="code">
                {{
                  $t("subscription.promotional_code.invalid", { code: code })
                }}
              </template>
              <template v-else>
                <div class="no-payment-methods-available">
                  {{ $t("subscription.no_payment_methods_available") }}
                </div>
              </template>
            </div>
          </div>
        </template>
        <hr class="separator" />
      </template>
    </div>

    <div class="block payment-form-container" v-if="!hideFormComponent">
      <div class="form-container" v-if="formComponent">
        <PaymentCountrySelector
          ref="paymentCountrySelector"
          :defaultCountry="paymentCountryId"
          @paymentCountryUpdated="paymentCountryUpdated"
        />
      </div>
      <div class="form-container" v-if="formComponent">
        <component
          :is="formComponent"
          :purchaseOption="purchaseOption"
          :paymentMethod="selectedPaymentMethod"
          :selectedCountry="selectedCountry"
          :hasToAcceptNoTrial="hasToAcceptNoTrial"
          :hasToAcceptNoPromo="hasToAcceptNoPromo"
          :resultMessage="resultMessage"
          :recurrent="!isOneTimePayment"
          :paymentCountry="paymentCountryId"
          @submit="submitHandler"
          @loadingChange="loadingChange"
        />

        <!--
                <div class="result-message" v-if="resultMessage">
                    <p>
                        {{resultMessage}}
                    </p>
                </div>
                -->
        <!-- Show message indicating that if payment link is not opened, use should click in the link. -->
        <div ref="resultMessage" class="result-message" v-if="resultMessage && resultMessage.redirect === 'no_callback_url'">
          <p>
            {{ $t("subscription.messages.no_callback_url") }}
            <br />
            <br />
            <a :href="resultMessage.url" target="_blank" class="btn">
              {{ $t("subscription.messages.no_callback_url_link_text") }}
            </a>
          </p>
        </div>
      </div>
      <div class="form-none" v-else>
        <div class="square">
          <h2 v-if="subscriptionPlan.payment_methods.data.length >= 1">
            {{ $t("subscription.select_payment_method") }}
          </h2>
        </div>
      </div>
    </div>

    <div v-if="hideFormComponent">
      <RyvylFlexForm
        :scriptData="scriptData"
        :paymentCountryCode="paymentCountryCode"
      />
    </div>
  </div>
</template>
<script>
import resources from "../../resources";
import Spinner from "../Spinner";
import PurchaseOption from "./SubscriptionForm.PurchaseOption";
import PurchaseOptionLegals from "../PurchaseOptionLegals";
import PurchaseInovioPay from "./SubscriptionForm.Purchase.InovioPay";
import PurchasePrePaidPromotionalCode from "./SubscriptionForm.Purchase.PrePaidPromotionalCode";
import PurchaseMercadopagoBasicForm from "./SubscriptionForm.Purchase.MercadopagoBasicForm";
import PurchaseTest from "./SubscriptionForm.Purchase.Test";
import PurchaseCcbillFlexformForm from "./SubscriptionForm.Purchase.CcbillFlexformForm";
import PurchaseRyvylFlexformForm from "./SubscriptionForm.Purchase.RyvylFlexformForm";
import RyvylFlexForm from "./Purchase/Ryvyl/FlexForm";
import PaymentMethodGroup from "../PaymentMethodGroup";
import AddOnLegacy from "./SubscriptionForm.Purchase.AddOnLegacy";
import PurchaseAstropayForm from "./SubscriptionForm.Purchase.AstropayForm";
import PaymentCountrySelector from "./SubscriptionForm.PaymentCountry";
import PurchaseNowPaymentsForm from "./SubscriptionForm.Purchase.NowPaymentsForm";
import PurchaseYapeForm from "./SubscriptionForm.Purchase.YapeForm";

import { PurchaseView } from "../../types/enums";
import { result } from "lodash";

export default {
  components: {
    PurchaseInovioPay,
    PurchaseCcbillFlexformForm,
    PurchaseRyvylFlexformForm,
    RyvylFlexForm,
    PurchaseMercadopagoBasicForm,
    PurchasePrePaidPromotionalCode,
    PurchaseTest,
    PurchaseOptionLegals,
    Spinner,
    PurchaseOption,
    PaymentMethodGroup,
    AddOnLegacy,
    PurchaseAstropayForm,
    PaymentCountrySelector,
    PurchaseNowPaymentsForm,
    PurchaseYapeForm,
  },
  props: {
    code: {
      required: false,
      default: null,
    },
    referal: {
      required: false,
      default: null,
    },
    purchaseOption: {
      type: Object,
      required: true,
      validator(purchaseOption) {
        if (
          !purchaseOption.subscription_plan ||
          !purchaseOption.subscription_plan.data
        )
          return true;

        return purchaseOption.subscription_plan.data.hasOwnProperty(
          "onward_subscription_plan"
        );
      },
    },
    selectedCountry: {
      required: true,
    },
    showCurrency: {
      required: true,
    },
    isOneTimePayment: {
      required: false,
      type: Boolean,
      default: false,
    },
    onlyOneOption: {
      required: false,
      type: Boolean,
      default: false,
    },
    view: {
      required: false,
      type: String,
      default: PurchaseView.default,
    },
  },
  data() {
    let forcedPaymentMethod = this.$route.query.payment_method || false;

    if (forcedPaymentMethod === "inovio") {
      forcedPaymentMethod = "ryvyl";
    }

    return {
      selectedPaymentMethod: null,
      resultMessage: {
        message: null,
        redirect: null,
        url: null,
        plan_id: null,
      },
      hasToAcceptNoTrial: null,
      hasToAcceptNoPromo: null,
      forcedPaymentMethod,
      __isMembershipActiveBlocked: false,
      __blockSubmit: false,
      paymentCountryId: null,
      paymentCountryCode: null,
      hideFormComponent: false,
      scriptData: null,
    };
  },
  created() {
    this.showPaymentMethodOptions();
    this.paymentCountryId =
      this.purchaseOption && this.purchaseOption.default_country_id
        ? this.purchaseOption.default_country_id
        : null;
  },
  methods: {
    backHandler(event) {
      this.$emit("back", event);
    },
    loginHandler(event) {
      this.$router.push({ name: "login" });
    },
    loadingChange(event) {
      this.$emit("loadingChange", event);
    },
    submitHandler(formData) {
      if (!this.$refs.paymentCountrySelector.checkCountry()) {
        return;
      }

      if (this.__blockSubmit) return;
      this.__blockSubmit = true;

      this.$emit("loadingChange", true);

      this.resultMessage.message = null;
      this.resultMessage.redirect = null;

      let subscription_plan_id = null;
      let subscription_plan_plus_legacy_id = null;

      if (this.purchaseOption.subscription_plan) {
        subscription_plan_id = this.purchaseOption.subscription_plan.data.id;
      }

      if (
        !["worldline"].includes(this.selectedPaymentMethod.key) &&
        this.showAddOnLegacy &&
        formData.addon_legacy
      ) {
        subscription_plan_plus_legacy_id =
          this.purchaseOption.subscription_plan.data.legacy_plus_webstar.id;
      }

      const data = {
        country_id: this.selectedCountry ? this.selectedCountry.id : "INT",
        form_data: formData,
        payment_method_id: this.selectedPaymentMethod
          ? this.selectedPaymentMethod.id
          : null,
        subscription_plan_id,
        subscription_plan_plus_legacy_id,
        promotional_code: this.purchaseOption.promotional_code
          ? this.purchaseOption.promotional_code.data.code
          : null,
        referal: this.referal,
        payment_link_id:
          this.purchaseOption.subscription_plan.data.payment_link_id,
        // payment_country_id: this.paymentCountryId,
      };

      resources.payments
        .store(data)
        .then((resp) => {
          setTimeout(() => {
            this.$emit("loadingChange", false);
            //Le damos tiempo, para que con el redirect no se vea que dejo de cargar, pero si hay un error en el redirect no rompemos el UI
          }, 2500);

          const redirect = resp.data.data.redirect;

          if (!redirect || !redirect.url) {
            this.$router.push({ name: "dashboard" });
            return;
          }

          switch (redirect.method.toLowerCase()) {
            case "script":
              this.hideFormComponent = true;
              this.scriptData = redirect;

              return;

            case "get":
              window.location.href = redirect.url;
              return;

            case "no_callback_url":
              // Try to open a new window.
              window.open(redirect.url, "_blank");
              this.resultMessage.message = this.$t("subscription.messages.check_payment_link");
              this.resultMessage.redirect = "no_callback_url";
              this.resultMessage.url = redirect.url;
              // Go to that id in the page to show the message.
              // Wait for DOM update then scroll
              this.$nextTick(() => {
                this.$refs.resultMessage.scrollIntoView();
              });
              return;

            case "post":
              const redirectForm = document.createElement("form");
              redirectForm.setAttribute("action", redirect.url);
              redirectForm.setAttribute("method", "post");
              redirectForm.setAttribute("hidden", "true");

              if (redirect.fields) {
                Object.keys(redirect.fields).forEach((key) => {
                  const fieldInput = document.createElement("input");
                  fieldInput.setAttribute("type", "hidden");
                  fieldInput.setAttribute("name", key);
                  fieldInput.setAttribute("value", redirect.fields[key]);
                  redirectForm.appendChild(fieldInput);
                });
              } else if (redirect.params) {
                Object.keys(redirect.params).forEach((key) => {
                  const fieldInput = document.createElement("input");
                  fieldInput.setAttribute("type", "hidden");
                  fieldInput.setAttribute("name", key);
                  fieldInput.setAttribute("value", redirect.params[key]);
                  redirectForm.appendChild(fieldInput);
                });
              }

              document.body.appendChild(redirectForm);
              redirectForm.submit();
              return;

            default:
              throw new Error("Unknown method");
          }

          /*
                    this.hasToAcceptNoTrial = false;
                    this.hasToAcceptNoPromo = false;
                    */
        })
        .catch((err) => {
          this.$emit("loadingChange", false);

          this.hasToAcceptNoTrial = false;
          this.hasToAcceptNoPromo = false;

          if (err.status === 422) {
            this.resultMessage.message = this.$t(
              "subscription.messages.validation_error"
            );
          } else if (err.status === 409) {
            this.hasToAcceptNoTrial = true;
            this.hasToAcceptNoPromo = true;
          } else if (err.status === 410) {
            this.hasToAcceptNoPromo = true;
          } else if (err.status === 411) {
            this.resultMessage.message = this.$t(
              "subscription.messages.login_required.message"
            );
            this.resultMessage.redirect = "login";
          } else if (err.status === 412) {
            const ccbill_flexform =
              this.subscriptionPlan.payment_methods.data.find(
                (payment_method) =>
                  payment_method.driver_front_key === "ccbill_flexform"
              );

            if (ccbill_flexform) {
              localStorage.setItem("paymentFailed", ccbill_flexform.id);
            }

            let failedCards =
              JSON.parse(localStorage.getItem("failedCards")) || [];
            let newFailedCard = {
              id: 0,
              details: {
                TRANS_STATUS_NAME: "PENDING",
                TRANS_ID: null,
                SERVICE_ADVICE: null,
              },
            };

            failedCards.push(newFailedCard);
            localStorage.setItem("failedCards", JSON.stringify(failedCards));

            // this.resultMessage.message = this.$t('subscription.messages.login_required.message');
            this.resultMessage.message =
              "Usted ya ha intentado un pago con éste procesador de pagos y no ha sido correcto. Si desea intentar con otro procesador de pagos";
            this.resultMessage.redirect = "home";
            this.resultMessage.plan_id = this.purchaseOption.subscription_plan
              ? this.purchaseOption.subscription_plan.data.id
              : null;
          } else if (err.status === 413) {
            this.resultMessage.message = err.body.message;
          } else {
            this.resultMessage.message = this.$t(
              "subscription.messages.server_error"
            );
          }
        })
        .finally(() => {
          this.__blockSubmit = false;
        });
    },
    setPaymentMethod(paymentMethod) {
      this.selectedPaymentMethod = paymentMethod;
      this.scrollToPaymentFormContainer();
    },
    scrollToPaymentFormContainer() {
      const el = this.$el.getElementsByClassName("payment-form-container")[0];

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    paymentCountryUpdated({ countryId, countryCode }) {
      this.paymentCountryId = countryId;
      this.paymentCountryCode = countryCode;
    },
    showPaymentMethodOptions() {
      const PREFERENTIAL_PAYMENT_METHOD =
        this.purchaseOption.preferential_payment_method;
      const PAYMENT_METHOD_NOW_PAYMENTS = "now_payments";

      const PRIORITY_PAYMENT_METHODS = [
        "ccbill_flexform",
        "inovio_pay",
        "ryvyl_flexform",
      ];

      // If there is preferential payment method, we show it first, so swap it with the first one in PRIORITY_PAYMENT_METHODS
      if (PREFERENTIAL_PAYMENT_METHOD) {
        // Search in debit
        let lIndex = -1;
        for (const [index, value] of Object.entries(PRIORITY_PAYMENT_METHODS)) {
          if (value === PREFERENTIAL_PAYMENT_METHOD) {
            lIndex = index;
            break;
          }
        }

        if (lIndex !== -1) {
          // Swap the preferential payment method with the first one in the list
          let aValue = PRIORITY_PAYMENT_METHODS[lIndex];
          PRIORITY_PAYMENT_METHODS[lIndex] = PRIORITY_PAYMENT_METHODS[0];
          PRIORITY_PAYMENT_METHODS[0] = aValue;
        }
      }

      // If there is no subscription plan, we don't need to show payment methods
      // Based on old comments, this could be a prepaid promo, since they dont have a subscription plan.
      if (!this.subscriptionPlan) {
        return;
      }

      // If there is a forced payment method, we force it. But if the plan does not have that payment method, the we show nothing.
      if (this.forcedPaymentMethod) {
        this.selectedPaymentMethod =
          this.subscriptionPlan.payment_methods.data.find(
            (payment_method) =>
              payment_method.key === this.forcedPaymentMethod.toLowerCase()
          );

        if (this.selectedPaymentMethod) {
          // Removing other payment methods
          this.subscriptionPlan.payment_methods.data.length = 1;
          this.subscriptionPlan.payment_methods.data[0] =
            this.selectedPaymentMethod;
          this.subscriptionPlan.payment_methods.data[0].director_cut = true;
          this.subscriptionPlan.payment_methods.data[0].director_cut_type =
            "query-forced";
        } else {
          this.subscriptionPlan.payment_methods.data.length = 0;
        }

        return;
      }

      // If there is only one payment method, we force it.
      if (this.subscriptionPlan.payment_methods.data.length === 1) {
        this.selectedPaymentMethod =
          this.subscriptionPlan.payment_methods.data[0];
        return;
      }

      this.subscriptionPlan.payment_methods.data.map((payment_method) => {
        if (payment_method.id === this.paymentFailed) {
          payment_method.group = "try-again";

          if (payment_method.driver_front_key === PREFERENTIAL_PAYMENT_METHOD) {
            let aValue = PRIORITY_PAYMENT_METHODS[1];
            PRIORITY_PAYMENT_METHODS[1] = PRIORITY_PAYMENT_METHODS[0];
            PRIORITY_PAYMENT_METHODS[0] = aValue;
          }
        } else if (
          payment_method.id !== this.paymentFailed &&
          payment_method.recommended === 1
        ) {
          payment_method.group = "recommended";
        } else {
          // (payment_method.id !== this.paymentFailed && payment_method.recommended === 0)
          payment_method.group = "others";
        }
      });

      // If its the first payment attempt, we show the recommended payment method.
      if (
        this.subscriptionPlan.payment_methods.data.some(
          (payment_method) =>
            payment_method.driver_front_key === PRIORITY_PAYMENT_METHODS[0]
        ) &&
        !this.failedCards
      ) {
        let PaymentMethodNowPayments =
          this.subscriptionPlan.payment_methods.data.find(
            (payment_method) =>
              payment_method.driver_front_key === PAYMENT_METHOD_NOW_PAYMENTS
          );

        let PaymentMethodPreferential =
          this.subscriptionPlan.payment_methods.data.find(
            (payment_method) =>
              payment_method.driver_front_key === PREFERENTIAL_PAYMENT_METHOD
          );

        let FirstPriorityMethod =
          this.subscriptionPlan.payment_methods.data.find(
            (payment_method) =>
              payment_method.driver_front_key === PRIORITY_PAYMENT_METHODS[0]
          );

        // Remove all payment methods:
        this.subscriptionPlan.payment_methods.data = [];
        this.selectedPaymentMethod = null;

        if (FirstPriorityMethod) {
          FirstPriorityMethod.director_cut = true;
          FirstPriorityMethod.director_cut_type = "preselected-payment_method";
          FirstPriorityMethod.group = "recommended";
          this.subscriptionPlan.payment_methods.data.push(FirstPriorityMethod);
        }

        if (FirstPriorityMethod.id !== PaymentMethodPreferential.id) {
          this.subscriptionPlan.payment_methods.data.push(
            PaymentMethodPreferential
          );
        }

        if (PaymentMethodNowPayments) {
          this.subscriptionPlan.payment_methods.data.push(
            PaymentMethodNowPayments
          );
        }

        if (this.subscriptionPlan.payment_methods.data.length === 1) {
          this.selectedPaymentMethod =
            this.subscriptionPlan.payment_methods.data[0];
        }
      }

      // // si tiene un pago aprobado, lo preselecciono y quito los otros métodos de pago
      // // solo si es el primer intento
      // else if (
      //   this.subscriptionPlan &&
      //   this.subscriptionPlan.last_approved_payment &&
      //   this.subscriptionPlan.payment_methods.data.some(
      //     (payment_method) =>
      //       payment_method.driver_front_key ===
      //       this.subscriptionPlan.last_approved_payment
      //   ) &&
      //   !this.failedCards
      // ) {
      //   this.selectedPaymentMethod = this.subscriptionPlan.payment_methods.data.find(
      //     (payment_method) =>
      //       payment_method.driver_front_key ===
      //       this.subscriptionPlan.last_approved_payment
      //   );
      //   // quitando los otros métodos de pago
      //   // TODO: usar métodos
      //   this.subscriptionPlan.payment_methods.data.length = 1;
      //   this.subscriptionPlan.payment_methods.data[0] = this.selectedPaymentMethod;
      //   this.subscriptionPlan.payment_methods.data[0].director_cut = true;
      //   this.subscriptionPlan.payment_methods.data[0].director_cut_type =
      //     "last-payment-success";
      // }
    },
  },
  computed: {
    purchaseOptionToShow() {
      let promotional_code = this.purchaseOption.promotional_code;

      if (
        this.purchaseOption.promotional_code &&
        ((this.purchaseOption.promotional_code.data.type_is_free_trial &&
          this.hasToAcceptNoTrial) ||
          this.hasToAcceptNoPromo)
      ) {
        promotional_code = null;
      }

      return {
        ...this.purchaseOption,
        promotional_code,
      };
    },
    promotionalCode() {
      return this.purchaseOption.promotional_code
        ? this.purchaseOption.promotional_code.data
        : null;
    },
    subscriptionPlan() {
      return this.purchaseOption.subscription_plan
        ? this.purchaseOption.subscription_plan.data
        : null;
    },
    formComponent() {
      if (this.hideFormComponent) {
        return null;
      }

      if (!this.selectedPaymentMethod) {
        if (this.promotionalCode && this.promotionalCode.type_is_pre_paid) {
          return "PurchasePrePaidPromotionalCode";
        } else {
          return null;
        }
      } else {
        switch (this.selectedPaymentMethod.driver_front_key) {
          case "test":
            return "PurchaseTest";
          case "inovio_pay":
            return "PurchaseInovioPay";
          case "mercadopago_basic":
            return "PurchaseMercadopagoBasicForm";
          case "ccbill_flexform":
            return "PurchaseCcbillFlexformForm";
          case "ryvyl_flexform":
            return "PurchaseRyvylFlexformForm";
          case "astropay":
            return "PurchaseAstropayForm";
          case "now_payments":
            return "PurchaseNowPaymentsForm";
          case "yape":
            return "PurchaseYapeForm";
          default:
            throw Error(
              `Unknown driver key "${this.selectedPaymentMethod.driver_front_key}"`
            );
        }
      }
    },
    failedCards() {
      return JSON.parse(localStorage.getItem("failedCards")) || false;
    },
    paymentFailed() {
      return JSON.parse(localStorage.getItem("paymentFailed")) || false;
    },
    showAddOnLegacy() {
      const isVisitor = !this.$auth.ready() || !this.$auth.check();

      const cond =
        !this.isOneTimePayment &&
        this.selectedPaymentMethod &&
        (["worldline", "ryvyl"].includes(this.selectedPaymentMethod.key) ||
          this.purchaseOption.subscription_plan.data.legacy_plus_webstar) &&
        this.purchaseOption.subscription_plan.data.is_webstars_plan &&
        !this.purchaseOption.subscription_plan.data.is_legacy_plus_webstar;

      if (!isVisitor && !this.__isMembershipActiveBlocked) {
        this.$auth
          .fetch()
          .then((data) => data.body.data)
          .then((user) => {
            this.$auth.user().membership_active = user.membership_active;
          });
        this.__isMembershipActiveBlocked = true;
      }

      return cond && (isVisitor || !this.$auth.user().membership_active);
    },
  },
  watch: {
    selectedPaymentMethod() {
      this.resultMessage.message = null;
      this.resultMessage.redirect = null;
    },
    formComponent() {
      this.hasToAcceptNoTrial = false;
      this.hasToAcceptNoPromo = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";
@import "../../styles/themes/chads";

.purchase {
  width: 100%;

  .separator {
    display: none;
  }

  .form-none {
    padding: 0 2em;

    .square {
      border-radius: 3px;
      display: flex;
      min-height: 200px;
      justify-content: space-around;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.35);
      align-items: center;
      color: var(--pallete_main_color);
    }
  }

  @media (max-width: 1150px) {
    max-width: 500px;
    width: auto;
    min-width: auto;
    flex-direction: column;

    .block {
      width: 100%;
    }

    .separator {
      display: block;
    }

    .form-none {
      display: none;
    }
  }
}

.subscription-plan-data {
  .text {
    .commercial {
      text-align: center;
    }

    .legal {
      font-size: 0.8em;
    }
  }
}

.login {
  display: block;
  width: fit-content;
  margin: 0 auto;

  .btn.back {
    @extend %fresh-btn;

    display: block;
    margin: 0;
    margin-block: 0.5em;
    border-radius: 14px;
    font-size: 1.7em;

    @media (max-width: 430px) {
      font-size: 1.4em;
    }
  }

  .text {
    display: block;
    width: 75%;
    margin: 0 auto;
    text-align: center;
    font-size: 1.5em;
    text-transform: uppercase;
  }
}

.payment-methods-container {
  .single-payment-method {
    display: block;
    width: 75%;
    margin: 0 auto;

    .action {
      text-align: center;
      margin: 0;
      margin-block: 0.25em 0.5em;
      font-size: 1.5em;
      text-transform: uppercase;
    }

    .payment-method-img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 70%;
      height: 70px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }

    @media (max-width: 430px) {
      .payment-method-img {
        width: 35%;
        height: 35px;
      }
    }
  }

  .no-payment-methods-available {
    color: var(--pallete_main_color);
    text-align: center;
    margin-top: 50px;
    font-size: 1.3em;
  }
}

.form-container {
  margin-top: 30px;
  margin-bottom: 30px;
}

.buttons-container {
  margin-bottom: 0.5em;
  display: flex;
  justify-content: space-around;

  .btn.back {
    @extend %fresh-btn;
  }

  .btn.submit {
    @extend %BASIC_BTN;
  }
}

.result-message {
  text-align: center;
  color: black;
  font-weight: bold;

  a {
    color: var(--pallete_main_color);
    text-decoration: underline;
  }

  a.btn {
    background-color: unset;
    border: 1px solid var(--pallete_main_color);
    border-radius: 35px;
    color: var(--pallete_main_color);
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 700;
    text-decoration: none;
    text-transform: uppercase;
    transition: all .25s linear;

    &:hover {
      background-color: var(--pallete_main_color);
      color: var(--pallete_clear_color);
    }
  }
}

.payment-disclaimer {
  text-align: center;
  font-size: 0.75em;
}
</style>
